<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      :width="740"
      centered
      :mask-closable="false"
      @cancel="close"
      @ok="onSubmit"
    >
      <div class="comment-edit_editor">
        <a-form-model ref="form" layout="inline" :model="form">
          <a-form-model-item v-if="needComment===2">
            <a-checkbox @change="checkStatus(3)"><a-tag color="blue">排查完成</a-tag>咨询类问题，您已排查完成，准备将回复同步至客服</a-checkbox>
            <a-checkbox @change="checkStatus(4)"><a-tag color="green">已解决</a-tag>是一个线上问题，您已经完成了包括但不限于数据修复，代码更改等手段来解决用户问题</a-checkbox>
            <a-checkbox @change="checkStatus(5)"><a-tag color="purple">功能后续优化</a-tag>产品设计上可能有遗漏或者需要进一步优化，需要进行优化</a-checkbox>
          </a-form-model-item>
          <a-form-model-item v-if="needComment === 1" label="工单打回原因：">
            <a-select v-model="form.comment" show-search placeholder="工单打回原因" style="width: 240px;" @change="handlerChange">
              <a-select-option v-for="(reason, index) in ticketBackReason" :key="index" :value="reason.label">{{ reason.label }} </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="needComment === 1" label="备注" prop="comment" :rules="{required:giveBackResult===1}">
            <vditor-editor v-model="form.comment" :height="200" />
          </a-form-model-item>
          <a-form-model-item v-if="needComment === 0 || needComment === 2" label="备注" prop="comment" :rules="{ required: true, message: '备注不能为空' }">
            <vditor-editor v-model="form.comment" :height="200" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import VditorEditor from '@/components/VditorEditor';
import { ticketStatus, ticketBackReason } from '@/utils/dictionary';

export default {
  name: 'TicketStatusChangeModal',
  components: { VditorEditor },
  props: {
    title: {
      type: String,
      default: '工单状态变更'
    },
    isResult: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      ticketStatus,
      needComment: 0,
      giveBackResult: 0,
      ticketBackReason,
      finalStatus: 3,
      statusFrom: null,
      statusTo: null,
      form: {
        comment: ''
      }
    };
  },
  methods: {
    onChange(value) {
      this.finalStatus = value;
      this.statusTo = value;
    },
    checkStatus(value) {
      this.finalStatus = value;
    },
    handlerChange(value) {
      this.form.comment = value;
      if (value === '其他') {
        this.form.comment = this.form.comment + ':';
        this.giveBackResult = 1;
      }
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
      this.form.comment = '';
    },
    open(statusFrom, statusTo, needComment) {
      this.statusFrom = statusFrom;
      this.statusTo = statusTo;
      this.visible = true;
      this.needComment = needComment;
    },
    onSubmit() {
      this.$refs.form.clearValidate();
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('callback', this.form.comment, this.finalStatus);
          this.close();
        }
      });
    }
  }
};
</script>

  <style lang="less" scoped>
  .edit-status {
    cursor: pointer;
    display: inline-block;
    padding: 0 4px;
    line-height: 22px;
    .icon-down {
      opacity: 0;
    }
  }
  .edit-status:hover {
    cursor: pointer;
    background-color: #e4e4e4;
    .icon-down {
      opacity: 1;
    }
  }
  .comment-edit_editor{
    .ant-checkbox-wrapper{
      margin-left :0px;
    }
  }
  </style>

